import { Component, Input, OnChanges } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Moneybar } from '@shared/funding/moneybar';

@Component({
  selector: 'app-moneybar-sidepanel',
  templateUrl: 'moneybar-sidepanel.component.html',
  styleUrls: ['moneybar-sidepanel.component.scss'],
  standalone: false,
})
export class MoneybarSidepanelComponent implements OnChanges {
  @Input() moneybarData!: Moneybar;
  @Input() color: ThemePalette | 'grey' = 'primary';

  receivedPercentage!: number;
  futurePercentage!: number;
  pledgedPercentage!: number;
  bufferPercentage!: number;

  constructor() {}

  ngOnChanges(): void {
    if (this.moneybarData) {
      this.calCulatePercentages();
    }
  }

  calCulatePercentages(): void {
    this.receivedPercentage = (this.moneybarData.donated / this.moneybarData.goal) * 100;
    this.futurePercentage = (this.moneybarData.presentValueOfFuturePayments / this.moneybarData.goal) * 100;
    this.pledgedPercentage =
      ((this.moneybarData.donated + this.moneybarData.presentValueOfFuturePayments) / this.moneybarData.goal) * 100;
    this.bufferPercentage = (this.moneybarData.buffer / this.moneybarData.goal) * 100;
  }
}
